export default __webpack_public_path__ + "static/media/delivery.95ef901f.jpg";